import {
  ColumnOptionsBase,
  EntityColumn,
  entityColumn,
  GridRef,
  GroupColumnRef, numberColumn,
  ServerSideColumnOption,
  stringColumn
} from '@softapps/core';
import { Account } from './account';
import { Signal } from '@angular/core';
import { Translation } from '@softline/ui-core';
import { AccountColumnComponent } from './account-column.component';

export interface ClientSideAccountColumnOptions<TRow extends object> extends ColumnOptionsBase<TRow, Account> {
  rowGroup?: boolean;
}

export interface ServerSideAccountColumnOptions<TRow extends object> extends ColumnOptionsBase<TRow, Account>, ServerSideColumnOption {
  rowGroup?: boolean;
}

export type AccountColumnOptions<TRow extends object> = ClientSideAccountColumnOptions<TRow> | ServerSideAccountColumnOptions<TRow>;

export function accountColumn<TRow extends object>(ref: GridRef<TRow> | GroupColumnRef<TRow>,
                                                 translator: (key: string) => Signal<Translation>,
                                                 options: AccountColumnOptions<TRow>): EntityColumn<TRow, Account>{
  return entityColumn(ref, {
    ...options,
    format: v => `${v.nummer} - ${v.kurzbez}`,
    sortBy: v => v.nummer,
    cellRenderer: AccountColumnComponent,
    serverSideSortField: 'nummer',
  }, entityRef => {
    numberColumn(entityRef, {
      colId: 'number',
      header: translator('Nummer'),
      getValue: v => v.nummer
    });
    stringColumn(entityRef, {
      colId: 'name',
      header: translator('Name'),
      getValue: v => v.kurzbez
    });
  });
}
